<template>
  <div class="mask-content">
    <div
      class="coupon-item position-relative"
      v-for="(item,index) in couponList"
      :key="index"
      @click="reCoupon(item,index)"
    >
      <div class="position-relative d-flex flex-row van-row--align-center">
        <div class="flex-1 con">
          <div class="left">
            <span class="title">{{item.name}}</span>
            <span class="time">有效期至{{item.endTime}}</span>
          </div>
          <div class="right">
            <span class="price">{{item.denomination}}</span>
            <span v-if="item.category == 1">满{{item.fullNumber}}可用</span>
            <span v-if="item.category == 0">无门槛使用</span>
          </div>
        </div>
        <div class="yticon icon-xuanzhong2 checkbox" :class="{checked: checkIndex == index}"></div>

        <div class="circle l"></div>
        <div class="circle r"></div>
      </div>

      <div class="con">
        <div class="left"></div>
        <div v-if="item.used" class="right getEd">已使用</div>
        <div v-if="!item.used&&item.fullNumber>fullNumber" class="right getEd">不可用</div>
        <div v-if="!item.used&&item.fullNumber<=fullNumber" class="right get">可使用</div>
      </div>

      <div class="mask" v-if="item.used||(!item.used&&item.fullNumber>fullNumber)"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'my-coupon-own-list',
  props: {
    couponList: {
      type: Array,
      default: () => {
        return []
      }
    },
    fullNumber: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      checkIndex: -1
    }
  },
  mounted () {
  },
  methods: {
    reCoupon (coupon, index) {
      if (coupon.fullNumber > this.fullNumber) {
        return
      }
      if (this.checkIndex == index) {
        this.checkIndex = -1
        this.$emit('cancelCoupon')
      } else {
        this.checkIndex = index
        this.$emit('reCoupon', coupon)
      }
    }
  },
}
</script>
<style lang="scss" scoped>
/* 优惠券列表 */
.mask-content {
  width: 100%;
}
.coupon-item {
  display: flex;
  flex-direction: column;
  margin: 10px 12px;
  background: #fff;

  .con {
    display: flex;
    align-items: center;
    position: relative;
    padding: 5px 15px;

    &:after {
      position: absolute;
      left: 0;
      bottom: 0;
      content: "";
      width: 100%;
      height: 0;
      border-bottom: 1px dashed #f3f3f3;
      transform: scaleY(50%);
    }
  }

  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    overflow: hidden;
  }

  .title {
    font-size: 16px;
    color: $font-color-dark;
    margin-bottom: 5px;
  }

  .time {
    font-size: 12px;
    color: $font-color-light;
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    font-size: 13px;
    color: $font-color-base;
  }
  .get {
    background-color: var(--theme-font-color);
    color: white;
    padding: 2px 10px;
    border-radius: 50px;
  }
  .getEd {
    background-color: grey;
    color: white;
    padding: 2px 10px;
    border-radius: 50px;
  }

  .price {
    font-size: 22px;
    color: $base-color;

    &:before {
      content: "￥";
      font-size: 17px;
    }
  }

  .tips {
    font-size: 12px;
    color: $font-color-light;
    line-height: 30px;
    padding-left: 30px;
  }

  .circle {
    position: absolute;
    left: -3px;
    bottom: -5px;
    z-index: 10;
    width: 10px;
    height: 10px;
    background: #f3f3f3;
    border-radius: 100px;

    &.r {
      left: auto;
      right: -3px;
    }
  }
}
.checkbox {
  font-size: 22px;
  line-height: 1;
  padding: 0px 15px 0 0;
  color: $font-color-disabled;
  background: #fff;
  border-radius: 50px;
}
.checked {
  color: var(--theme-font-color);
}
.mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 9;
  background-color: rgba(255, 255, 255, 0.6);
}
</style>